import { useTranslation } from 'react-i18next';
export default function ValuesSection() {

  const { t } = useTranslation();
  const values = [
    {
      icon: 'ri-handshake-line',
      title: t('about.co'),
      subtitle: 'WIN-WIN',
      description: t('about.co.desc')
    },
    {
      icon: 'ri-shield-check-line',
      title: t('about.safety'),
      subtitle: 'SECURITY',
      description: t('about.safety.desc')
    },
    {
      icon: 'ri-award-line',
      title: t('about.integrity'),
      subtitle: 'TRUST',
      description:t('about.integrity.desc')
    },
    {
      icon: 'ri-medal-line',
      title: t('about.professional'),
      subtitle: 'EXCELLENCE',
      description: t('about.professional.desc'),
    },
    {
      icon: 'ri-flashlight-line',
      title: t('about.fast'),
      subtitle: 'EFFICIENCY',
      description: t('about.fast.desc')
    }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-amber-50/30 to-yellow-50/30"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('about.coreValue')}</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">{t('about.coreValue.desc')}</p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="relative group"
              >
                <div className="bg-white border-2 border-amber-200 rounded-lg p-6 text-center hover:border-amber-400 transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1">
                  <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${value.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{value.title}</h3>
                  <p className="text-sm font-semibold text-amber-600 mb-3">{value.subtitle}</p>
                  <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Central logo
        
        <div className="text-center mt-16">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full shadow-xl">
            <span className="text-white font-bold text-2xl">GL</span>
          </div>
          <p className="text-lg font-semibold text-gray-700 mt-4">Corporate Culture</p>
        </div>

        */}
      </div>
    </section>
  );
}
